import React from 'react';
import styled from 'styled-components';
import eyeIcon from '../../../assets/visibility.png';
import { rotuloTipoAtividade } from '../../../constants/tipoAtividade';
import BadgeInstituicao from './BadgeInstituicao';
import { STATUS_LEGENDA } from './constantes';

const Moldura = styled.div`
  overflow-x: auto;
  background: white;
`;

const Tabela = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Public Sans', sans-serif;
`;

const Cabecalho = styled.th`
  padding: 16px 20px;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  color: #6ab8a8;
  background: #f2f0f0;
  border-bottom: 1px solid #dfe3e8;
  border-right: 2px solid #dfe3e8;

  &:first-child {
    text-align: left;
    padding-left: 40px;
  }

  &:last-child {
    border-right: none;
  }
`;

const Linha = styled.tr`
  border-bottom: 1px solid #e6e6e6;

  &:nth-child(odd) {
    background: #e8f5f3;
  }

  &:nth-child(even) {
    background: #ffffff;
  }
`;

const Celula = styled.td`
  padding: 12px 20px;
  font-size: 15px;
  color: #555555;
  text-align: center;
  border-right: 2px solid #dfe3e8;
  font-weight: 500;

  &:first-child {
    text-align: left;
    padding-left: 40px;
  }

  &:last-child {
    border-right: none;
  }
`;

const ComIcone = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;

  img {
    width: 24px;
    height: 24px;
  }
`;

const BotaoVisualizar = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;

  img {
    width: 22px;
    height: 22px;
  }
`;

const TabelaRelatorio = ({ itens, onVisualizar }) => (
  <Moldura>
    <Tabela>
      <thead>
        <tr>
          <Cabecalho>ESPECIALIDADES</Cabecalho>
          <Cabecalho>DISCIPLINA</Cabecalho>
          <Cabecalho>STATUS</Cabecalho>
          <Cabecalho>TIPO</Cabecalho>
          <Cabecalho>SETOR</Cabecalho>
          <Cabecalho>Nº ALUNOS</Cabecalho>
          <Cabecalho>Nº HORAS</Cabecalho>
          <Cabecalho>Nº TOTAL / HORAS ALUNOS POR UNID.</Cabecalho>
          <Cabecalho>VISUALIZAR</Cabecalho>
        </tr>
      </thead>
      <tbody>
        {itens.length === 0 ? (
          <tr>
            <Celula colSpan="9" style={{ textAlign: 'center', padding: '32px' }}>
              Nenhuma solicitação encontrada com os filtros aplicados.
            </Celula>
          </tr>
        ) : (
          itens.map((item) => {
            const status = STATUS_LEGENDA[item.status];
            return (
              <Linha key={item.id}>
                <Celula>
                  <ComIcone>
                    <BadgeInstituicao instituicao={item.instituicao} />
                    {item.area.nome}
                  </ComIcone>
                </Celula>
                <Celula>{item.nomeDisciplina}</Celula>
                <Celula>
                  <ComIcone>
                    <img src={status.icone} alt="" />
                    {status.rotulo}
                  </ComIcone>
                </Celula>
                <Celula>{rotuloTipoAtividade(item.tipoAtividade)}</Celula>
                <Celula>{item.setor.nome}</Celula>
                <Celula>{item.quantidadeAlunos}</Celula>
                <Celula>{item.horasPorAluno}h</Celula>
                <Celula>{item.totalHoras}h</Celula>
                <Celula>
                  <BotaoVisualizar
                    type="button"
                    title="Visualizar solicitação"
                    onClick={() => onVisualizar(item.id)}
                  >
                    <img src={eyeIcon} alt="Visualizar" />
                  </BotaoVisualizar>
                </Celula>
              </Linha>
            );
          })
        )}
      </tbody>
    </Tabela>
  </Moldura>
);

export default TabelaRelatorio;
